// Models
import { LayoutConfigModel } from '../models/layout-config.model';

// Enums
import { TenantIdType } from '../enums';

export class LayoutConfig {
	// Default Configs
	defaultFavicon: string = '../../assets/logos/default/favicon.png';
	defaultLogoLight: string = '../../../assets/logos/cudd/logo.png';
	defaultLogoLoader: string = '../../../assets/logos/default/logo-loader.png';

	// CUDD Configs
	cuddFavicon: string = '../../assets/logos/cudd/favicon.ico';
	cuddLogoDark: string = '../../../assets/logos/cudd/logo-dark.png';
	cuddLogoLight: string = '../../../assets/logos/cudd/logo-light.png';
	cuddLogoLoaderDark: string = '../../../assets/logos/cudd/logo-loader-dark.png';
	cuddLogoLoaderLight: string = '../../../assets/logos/cudd/logo-loader-light.png';
	cuddPrimaryColor: string = '#81302f';

	// TTS Configs
	ttsFavicon: string = '../../assets/logos/tts/favicon.ico';
	ttsLogoDark: string = '../../../assets/logos/tts/logo-dark.png';
	ttsLogoLight: string = '../../../assets/logos/tts/logo-light.png';
	ttsLogoLoaderDark: string = '../../../assets/logos/tts/logo-loader-dark.png';
	ttsLogoLoaderLight: string = '../../../assets/logos/tts/logo-loader-light.png';
	ttsPrimaryColor: string = '#0a51a3';

	defaults: LayoutConfigModel = {
		tenantId: 0,
		self: {
			layout: 'fluid', // fluid|boxed
			body: {
				'background-image': '../../../assets/images/background-1.jpg',
			},
			logo: {
				dark: this.defaultLogoLight,
				light: this.defaultLogoLight,
				brand: this.defaultLogoLight,
				green: this.defaultLogoLight,
			},
		},
		loader: {
			enabled: true,
			type: 'spinner-logo',
			logoDark: this.defaultLogoLoader,
			message: 'Please wait...',
			color: '#5d78ff',
		},
	};

	/*** Getting the default remote config*/
	get getDefaultConfigs(): LayoutConfigModel {
		this.defaults.tenantId = 0;
		return this.defaults;
	}

	/*** Getting the CUDD remote config*/
	get getCuddConfigs(): LayoutConfigModel {
		let configs = this.defaults;
		configs.tenantId = TenantIdType.CUDD;
		configs.self.logo = {
			dark: this.cuddLogoDark,
			light: this.cuddLogoLight,
			brand: this.cuddLogoLight,
			green: this.cuddLogoLight,
		};

		configs.loader.logoDark = this.cuddLogoLoaderDark;
		configs.loader.logoLight = this.cuddLogoLoaderLight;
		configs.loader.color = this.cuddPrimaryColor;

		return configs;
	}

	/*** Getting the TTS remote config*/
	get getTtsConfigs(): LayoutConfigModel {
		let configs = this.defaults;
		configs.tenantId = TenantIdType.TTS;
		configs.self.logo = {
			dark: this.ttsLogoDark,
			light: this.ttsLogoLight,
			brand: this.ttsLogoLight,
			green: this.ttsLogoLight,
		};

		configs.loader.logoDark = this.ttsLogoLoaderDark;
		configs.loader.logoLight = this.ttsLogoLoaderLight;
		configs.loader.color = this.ttsPrimaryColor;

		return configs;
	}
}
